export default "__VITE_ASSET__Dei3DMQT__"